import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#3A3A88"
      d="M20 3.375v3.563c0 .69-.56 1.25-1.25 1.25h-3.563a1.25 1.25 0 0 1 0-2.5h.956A7.452 7.452 0 0 0 10 2.5a7.458 7.458 0 0 0-6.987 4.768 1.25 1.25 0 0 1-2.328-.911 9.985 9.985 0 0 1 3.613-4.573A9.941 9.941 0 0 1 10 0c2.051 0 4.023.617 5.701 1.784.668.463 1.27 1 1.799 1.599v-.008a1.25 1.25 0 1 1 2.5 0Zm-1.393 8.649a1.25 1.25 0 0 0-1.62.708A7.458 7.458 0 0 1 10 17.5a7.453 7.453 0 0 1-6.054-3.063h.866a1.25 1.25 0 1 0 0-2.5H1.25c-.69 0-1.25.56-1.25 1.25v3.563a1.25 1.25 0 1 0 2.5 0v-.133a10.06 10.06 0 0 0 1.798 1.6A9.941 9.941 0 0 0 10 20a9.941 9.941 0 0 0 5.701-1.784 9.984 9.984 0 0 0 3.614-4.573 1.25 1.25 0 0 0-.708-1.62Z"
    />
  </svg>
)
export default SvgComponent
